module.exports = require("./vai-Latn");